module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-landing"
  }, [_c('div', {
    staticClass: "hero is-primary section-main",
    attrs: {
      "id": "section-main"
    }
  }, [_c('div', {
    staticClass: "hero-cover"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    }
  }, [(false) ? _c('fb-login') : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_vm._m(0), _c('div', [_c('div', {
    staticClass: "title",
    staticStyle: {
      "display": "flex",
      "max-width": "200px",
      "margin": "auto"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true",
      "data-aos-delay": "500"
    }
  }, [_c('span', {
    staticClass: "typewriter-start typewriter"
  }, [_c('div', [_c('a', {
    staticClass: "page-scroll",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$scrollTo('#section-main-showcase', {
          offset: 80
        })
      }
    }
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("$")]), _vm._v(" "), _c('span', {
    staticClass: "color-orange"
  }, [_vm._v(": _")]), _vm._v("  "), _c('span', {
    staticStyle: {
      "width": "100%",
      "margin-right": "10px",
      "margin-bottom": "1em"
    }
  }, [_vm._v("HERE")]), _vm._v(" ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hero is-primary section-main section-main-reversed",
    attrs: {
      "id": "section-main-2"
    }
  }, [_c('div', {
    staticClass: "hero-cover hero-cover-reversed"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "title",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "typewriter-start typewriter"
  }, [_c('div', [_c('a', {
    staticClass: "page-scroll",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$scrollTo('#section-main-3', {
          offset: -50
        })
      }
    }
  }, [_c('span', {
    staticClass: "color-orange"
  }, [_vm._v("_")]), _vm._v(" thought "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("_")]), _vm._v("  ")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p')])])])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "hero is-primary section-main section-main-highlighted",
    attrs: {
      "id": "section-main-3"
    }
  }, [_c('div', {
    staticClass: "hero-cover hero-cover-highlighted"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_vm._m(2), _c('div', {
    staticClass: "title",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "typewriter-start typewriter"
  }, [_c('div', [_c('a', {
    staticClass: "page-scroll",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$scrollTo('#section-main-4', {
          offset: -50
        })
      }
    }
  }, [_vm._m(3), _vm._v(" re-order "), _c('span', {
    staticClass: "color-orange"
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("_")]), _vm._v("  ")])])])]), _vm._v(" "), _c('p')])])])])]) : _vm._e(), _vm._v(" "), (false) ? _c('content-project-list-section', {
    attrs: {
      "id": "section-main-showcase"
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('content-service-list-section') : _vm._e(), _vm._v(" "), (false) ? _c('top-section') : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), (false) ? _c('content-project-list-section') : _vm._e(), _vm._v(" "), (false) ? _c('content-quote-section') : _vm._e(), _vm._v(" "), (false) ? _c('section-comment') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title capital has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_vm._v("\n              Let's Build"), _c('br'), _vm._v("\n              Something "), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("Great")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../assets/logo2.svg"),
      "width": "240px",
      "data-pin-nopin": "true"
    }
  }), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title capital",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("Cast")]), _vm._v(" a "), _c('span', {
    staticClass: "color-orange"
  }, [_vm._v("reflection")]), _vm._v(" :"), _c('br'), _vm._v("\n              of your"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title capital",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_vm._v("\n              Succumb to "), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("..")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#A01A37"
    }
  }, [_vm._v("chaos")]), _c('br'), _vm._v("\n              or "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": require("../assets/chaos-graph.gif"),
      "width": "300px",
      "data-aos": "fade-right",
      "data-aos-once": "true",
      "data-pin-nopin": "true"
    }
  }), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "color-blue"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero is-primary section-main section-main-ads",
    attrs: {
      "id": "section-main-5"
    }
  }, [_c('div', {
    staticClass: "hero-cover hero-cover-ads"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2 has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "1rem"
    },
    attrs: {
      "src": require("../assets/ads.jpg")
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("\"we'll be right back after this commercial break.\"")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28c12467","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Landing.vue
// module id = 808
// module chunks = 1